import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filters: {
        "sort": {
            "attributes": ["created_date"],
            "sorts": ["desc"]
        }
    },
    eventsFilter: {
        "search": "",
        "sort": {
            "attributes": ["fromDate"],
            "sorts": ["desc"]
        },
        "filters":[]
    },
};

const homePageSlice = createSlice({
    name: 'homePage',
    initialState,
    reducers: {
        updateFilter: (state, action) => {
            state.filters = action.payload;
        },
        updateReducer: (state, action) => {
            state.filters = action.payload;
        },
        updateEventFilter: (state, action) => {
            state.eventsFilter = action.payload;
        }
    },
});

export const {
    updateFilter,
    updateReducer,
    updateEventFilter
} = homePageSlice.actions;

export default homePageSlice.reducer;
